import React from 'react';
import SubscribeForm from '@forms/form-types/subscribe-form';
import Translate from '@components/translation/translate-text-wrapper';

interface SubscribeInfoProps {
  title: string;
  id: number;
  message: null | string;
}

/**
 * Get Subscribe Form Info.
 */
const getSubscribeInfo = (formType: string): SubscribeInfoProps => {
  let title = '';
  let message: null | string;
  let id = 0;
  switch (formType) {
    case 'newsroom':
      title = 'Stay up to date';
      message = 'Sign up to receive regular news from Varian.';
      id = 0;
      break;
    case 'centerline':
      title = 'Get Centerline Delivered to Your Inbox.';
      id = 0;
      break;
    case 'spoton':
      title = 'Get Spot ON Delivered to Your Inbox.';
      id = 0;
      break;
    default:
      break;
  }

  return { title, message, id };
};

/**
 * Newsroom Subscribe.
 *
 * @returns
 */
const NewsroomSubscribe = ({ formType }): JSX.Element => {
  const { title, message, id } = getSubscribeInfo(formType);

  /**
   * Render.
   */
  return (
    <div className="newsroom-sidebox newsroom-subscribe center-vertically background-gray-lightest medium-vertical-margin medium-vertical-padding medium-horizontal-padding">
      <h3>
        <Translate>{title}</Translate>
      </h3>
      <p>
        <Translate>{message}</Translate>
      </p>
      <div className="link-container">
        <SubscribeForm marketoId={id} formType={formType} />
      </div>
    </div>
  );
};

export default NewsroomSubscribe;
